import { get } from "app/utils/axios/kheti";
import { FarmerCreditResponse } from "../models/credit";
import ToastAndroid from "app/mocks/ToastAndroid";

const fetchFarmerRepaymentTransactionDetails = async (
  farmerId: string,
  nextPageUrl?: string | null,
): Promise<FarmerCreditResponse | null> => {
  try {
    const url =
      nextPageUrl ?? `/farmer-360/v1/farmer/${farmerId}/repayment-transaction`;
    const response = await get<FarmerCreditResponse>(url);

    return response;
  } catch (e) {
    ToastAndroid.show(
      "Failed to fetch repayment transactions.",
      ToastAndroid.SHORT,
    );
    return null;
  }
};

export default fetchFarmerRepaymentTransactionDetails;
